/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'prettyPrintUpdatedBy',
    standalone: false
})
export class PrettyPrintUpdatedByPipe implements PipeTransform {
    transform(cellValue: { username: string, email: string }): string {
        let value = null;
        if (cellValue != null) {
            if (cellValue?.email && cellValue?.username) {
                value = `${cellValue.email} (${cellValue.username})`;
            } else {
                value = `${cellValue.username}`;
                value = cellValue.username ? `${cellValue.username}` : null;
            }
        }
        return value;
    }
}

